/* ============================================================================
   MailBakes — in-cart slice upgrade
   assets/mb-slice-upsell.js

   Offers the next slice tier on each cake card in the basket, lets the customer
   pick flavours for the new slices, then writes the changes and reloads — the
   same add-then-reload pattern the rest of this cart uses.

   WHY THIS IS SELF-CONTAINED
   --------------------------
   It injects its own markup and styles rather than being rendered by
   sections/mb-cart.liquid. That section is 35KB of hand-tuned, heavily
   commented Liquid, and rewriting it wholesale to add one block is a bad trade
   for a draft. The only theme edit this needs is one script tag in
   sections/mb-delivery.liquid, which already loads on the cart.

   THINGS THAT WILL BREAK IF YOU CHANGE THEM
   -----------------------------------------
   * Only ever set _mb_parent_group on the slice line — never _mb_group. A line
     with _mb_group renders as its own card AND inflates the card count that
     mb-delivery-cart.js uses to pick a postage tier, so postage would jump.
   * Never identify a row by data-line. That attribute is a Liquid loop counter
     that also counts the add-on lines the render loop skips, so it points at
     the wrong line. mb-cart.js documents it as the cause of the old "enter the
     address twice" bug. Rows are matched by data-group -> _mb_group -> key.
   * /cart/change.js REPLACES the whole properties hash. Always read current
     properties and merge, or the personalised message, font, colour and the
     entire shipping address are silently wiped.
   * Steps run sequentially. Each write invalidates the keys from the last one.

   Variant ids and prices are read from the slices product at runtime, so a
   price change in Shopify follows through — same principle as readTiers() in
   mb-delivery-cart.js.
   ============================================================================ */

(function () {
  'use strict';

  var CONFIG = {
    SLICE_HANDLE: 'option-set-821195-buttons-1',
    SLICE_PROP:   'One or Two Slices',

    /* The birthday upgrade is the one option whose card property does not
       equal its variant name: the flow shows it as "The Birthday Upgrade"
       (mb-flow.liquid setting upgrade_title) while the variant it charges is
       "The Ultimate Bundle" (matched on upgrade_match: "ultimate"). Without
       this line the repair below cannot recognise it, and the upgrade is the
       most expensive thing on the page to lose - order #189676 dropped £20.
       Rename either side in the theme editor and this needs updating. */
    TITLE_ALIASES: { 'The Birthday Upgrade': 'The Ultimate Bundle' },

    TIERS: [
      { title: 'Two Slices',  total: 2 },
      { title: 'Four Slices', total: 4 }
    ],

    FLAVOUR_KEYS: ['Flavour One', 'Flavour Two', 'Flavour Three', 'Flavour Four'],

    FLAVOURS: ['Victoria Sponge','Chocolate Fudge','Vanilla & Lemon','Chocolate & Nutella',
               'Vanilla & Chocolate','Vanilla & Lotus','The Bruce','The Plain Jane'],

    MODE: 'pick',

    COPY: {
      cta1:   'Add a second slice',
      proof1: 'Nearly 9 in 10 orders add extra slices',
      pill:   'Popular',
      cta2:   'Double it to four slices',
      proof2: 'Works out at [per] a slice',
      pickOne:'Which flavour for the extra slice?',
      pickMany:'Which flavours for the extra slices?',
      slot:   'Extra slice',
      hint:   'swipe for more',
      confirm:'Add for +[price]',
      cancel: 'Not now',
      busy:   'Adding...'
    }
  };

  var root = document.querySelector('[data-mb-cart]');
  if (!root) return;

  function json(url, options) {
    return fetch(url, options || { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Cart update failed');
          return d;
        });
      });
  }
  function post(url, body) {
    return json(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function money(p) { return '£' + (p / 100).toFixed(2); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  function styles() {
    if (document.getElementById('mb-up-css')) return;
    var css = document.createElement('style');
    css.id = 'mb-up-css';
    css.textContent = [
      '.mb-up{margin:0 0 14px}',
      '.mb-up__row{display:flex;align-items:center;gap:11px;width:100%;text-align:left;cursor:pointer;',
        'border:1px solid #f7d5e4;background:#fdf1f6;border-radius:10px;padding:12px 13px;font:inherit;color:inherit}',
      '.mb-up__row:hover{border-color:#ed217a}',
      '.mb-up__tx{flex:1;min-width:0}',
      '.mb-up__t1{display:block;font-size:14px;font-weight:700;color:#191416}',
      '.mb-up__t2{display:block;font-size:12.5px;color:#6f666b;margin-top:2px}',
      '.mb-up__pill{display:inline-block;background:#fff;color:#a81a5c;font-size:10.5px;font-weight:750;',
        'letter-spacing:.03em;padding:3px 8px;border-radius:999px;margin-left:7px}',
      '.mb-up__pr{font-size:14px;font-weight:750;color:#ed217a;white-space:nowrap}',
      '.mb-up__cv{color:#e3aac7;font-size:18px;line-height:1}',
      '.mb-up__pick{border:1px solid #f7d5e4;background:#fdf1f6;border-radius:10px;padding:12px 13px}',
      '.mb-up__hd{font-size:13.5px;font-weight:720;color:#191416}',
      '.mb-up__sub{font-size:12.5px;color:#6f666b;margin:2px 0 10px}',
      '.mb-up__slot{margin-bottom:9px}',
      '.mb-up__lb{display:flex;gap:8px;align-items:baseline;font-size:12px;font-weight:700;color:#6f666b;margin-bottom:6px}',
      '.mb-up__chosen{color:#ed217a;font-weight:750}',
      '.mb-up__hint{margin-left:auto;font-weight:400;color:#a99ea4}',
      '.mb-up__rail{display:flex;gap:6px;overflow-x:auto;scrollbar-width:none;padding-bottom:3px;',
        '-webkit-mask-image:linear-gradient(90deg,#000 calc(100% - 26px),transparent);',
        'mask-image:linear-gradient(90deg,#000 calc(100% - 26px),transparent)}',
      '.mb-up__rail::-webkit-scrollbar{display:none}',
      '.mb-up__fp{flex:none;border:1.5px solid #ece5da;background:#fff;border-radius:9px;padding:8px 12px;',
        'font:inherit;font-size:13px;color:#191416;white-space:nowrap;cursor:pointer}',
      '.mb-up__fp[aria-pressed="true"]{border-color:#ed217a;font-weight:700;box-shadow:inset 0 0 0 1px #ed217a}',
      '.mb-up__act{display:flex;gap:8px;align-items:center;margin-top:11px}',
      '.mb-up__go{flex:1;background:#ed217a;color:#fff;border:0;border-radius:999px;padding:12px;',
        'font:inherit;font-size:14px;font-weight:730;cursor:pointer}',
      '.mb-up__go:hover{background:#d41c6d}',
      '.mb-up__cancel{background:none;border:0;color:#6f666b;font:inherit;font-size:13px;padding:11px 12px;',
        'cursor:pointer;text-decoration:underline;text-underline-offset:2px}',
      '.mb-up__err{font-size:12.5px;color:#b3261e;margin:9px 0 0}',
      '.mb-up[data-mb-busy="1"]{opacity:.55;pointer-events:none}'
    ].join('');
    document.head.appendChild(css);
  }

  function parentLine(cart, group) {
    return cart.items.filter(function (it) {
      return (it.properties || {})._mb_group === group;
    })[0] || null;
  }

  function sliceLine(cart, group, productId) {
    return cart.items.filter(function (it) {
      var p = it.properties || {};
      return p._mb_parent_group === group && String(it.product_id) === String(productId);
    })[0] || null;
  }

  function tierIndex(title) {
    for (var i = 0; i < CONFIG.TIERS.length; i++) if (CONFIG.TIERS[i].title === title) return i;
    return -1;
  }

  function flavoursOf(props) {
    var out = [];
    Object.keys(props || {}).forEach(function (k) {
      if (k.indexOf('Flavour') > -1 && props[k]) out.push(props[k]);
    });
    return out;
  }

  function build(row, card, current, next, uplift, newSlots, firstFlavour, product) {
    var cardQty = Math.max(1, parseInt(card.quantity, 10) || 1);
    var perSlice = Math.round(uplift / newSlots);
    uplift *= cardQty;
    var isFirst  = current === null;
    var C = CONFIG.COPY;

    var slots = '';
    var have = flavoursOf(card.properties).length || 1;
    for (var i = 0; i < newSlots; i++) {
      var key = CONFIG.FLAVOUR_KEYS[have + i] || ('Flavour ' + (have + i + 1));
      var chips = CONFIG.FLAVOURS.map(function (f) {
        return '<button type="button" class="mb-up__fp" data-mb-flavour="' + esc(f) + '" ' +
               'aria-pressed="' + (f === firstFlavour ? 'true' : 'false') + '">' + esc(f) + '</button>';
      }).join('');
      slots +=
        '<div class="mb-up__slot" data-mb-slot="' + esc(key) + '" data-mb-default="' + esc(firstFlavour) + '">' +
          '<div class="mb-up__lb"><span>' + esc(C.slot) + ' ' + (i + 1) + '</span>' +
            '<span class="mb-up__chosen" data-mb-chosen>' + esc(firstFlavour) + '</span>' +
            (i === 0 ? '<span class="mb-up__hint">' + esc(C.hint) + '</span>' : '') +
          '</div>' +
          '<div class="mb-up__rail" role="radiogroup" aria-label="' + esc(key) + '">' + chips + '</div>' +
        '</div>';
    }

    var panel = document.createElement('div');
    panel.className = 'mb-up';
    panel.setAttribute('data-mb-upsell', '');
    panel.setAttribute('data-mb-group', card.properties._mb_group);
    panel.setAttribute('data-mb-variant', next.id);
    panel.setAttribute('data-mb-product', product.id);
    panel.setAttribute('data-mb-tier', next.title);
    panel.innerHTML =
      '<button type="button" class="mb-up__row" data-mb-open>' +
        '<span class="mb-up__tx">' +
          '<span class="mb-up__t1">' + esc(isFirst ? C.cta1 : C.cta2) +
            (isFirst && C.pill ? '<span class="mb-up__pill">' + esc(C.pill) + '</span>' : '') +
          '</span>' +
          '<span class="mb-up__t2">' +
            esc(isFirst ? C.proof1 : C.proof2.replace('[per]', money(perSlice))) +
          '</span>' +
        '</span>' +
        '<span class="mb-up__pr">+' + money(uplift) + '</span>' +
        '<span class="mb-up__cv" aria-hidden="true">&rsaquo;</span>' +
      '</button>' +
      '<div class="mb-up__pick" data-mb-pick hidden>' +
        '<div class="mb-up__hd">' + esc(isFirst ? C.cta1 : C.cta2) + '</div>' +
        '<div class="mb-up__sub">' + esc(newSlots > 1 ? C.pickMany : C.pickOne) + '</div>' +
        slots +
        '<p class="mb-up__err" data-mb-err hidden></p>' +
        '<div class="mb-up__act">' +
          '<button type="button" class="mb-up__go" data-mb-add>' +
            esc(C.confirm.replace('[price]', money(uplift))) + '</button>' +
          '<button type="button" class="mb-up__cancel" data-mb-cancel>' + esc(C.cancel) + '</button>' +
        '</div>' +
      '</div>';

    var top = row.querySelector('.mb-line__top');
    if (top && top.nextSibling) row.insertBefore(panel, top.nextSibling);
    else row.appendChild(panel);
  }

  /* ---- repair: a slice choice with nothing charging for it ---------------
     The product flow records the customer's choice on the CARD, as the
     property "One or Two Slices", and adds a separate line item for the
     upgrade. When the second thing fails and the first does not, the basket
     still reads "Two Slices" - it prints that from the card's own property -
     while nobody has been charged the £3.99. It is invisible from the basket,
     invisible at checkout, and invisible on the packing slip.

     Measured 16-17 Aug 2026: 8.6% of chargeable choices, £79.67 in a day and
     a half. mb-flow.js now sends the card and the slice in one request, which
     should stop it at source; this is the backstop for the paths that still
     post twice (photo cards) and for baskets built before that fix - two of
     the fourteen came from carts started days earlier.

     Deliberately conservative. It adds a line ONLY when the card names a tier
     that exactly matches a real, available variant on the slices product and
     that group has no slice line at all. It never edits an existing line,
     never guesses at a title it does not recognise, and does nothing if the
     lookup fails - charging nothing by accident is recoverable, charging the
     wrong thing is not.

     Same shape as the postage self-heal in mb-delivery-cart.js: repair, then
     reload, with a session flag so a repair that does not take cannot loop. */
  var REPAIR_FLAG = 'mbSliceRepair';

  function repairMissing(cart, product) {
    if (sessionStorage.getItem(REPAIR_FLAG) === '1') {
      sessionStorage.removeItem(REPAIR_FLAG);
      return false;
    }

    var wanted = [], corrections = [];

    cart.items.forEach(function (item) {
      var props = item.properties || {};
      var group = props._mb_group;
      if (!group) return;

      var chosen = String(props[CONFIG.SLICE_PROP] || '').trim();
      if (!chosen) return;

      /* Only titles we can match exactly against a live variant. "One slice"
         and anything unrecognised fall through and are left alone. */
      var target = CONFIG.TITLE_ALIASES[chosen] || chosen;
      var variant = product.variants.filter(function (v) {
        return v.title === target && v.available && v.price > 0;
      })[0];
      if (!variant) return;

      var existing = sliceLine(cart, group, product.id);
      if (existing) {
        if (existing.quantity !== item.quantity) corrections.push({ id: existing.key, quantity: item.quantity });
        return;
      }

      wanted.push({ id: variant.id, quantity: Math.max(1, parseInt(item.quantity, 10) || 1), properties: { _mb_parent_group: group } });
    });

    if (!wanted.length && !corrections.length) return false;

    corrections.reduce(function (chain, change) {
      return chain.then(function () { return post('/cart/change.js', change); });
    }, Promise.resolve()).then(function () {
      return wanted.length ? post('/cart/add.js', { items: wanted }) : null;
    })
      .then(function () {
        sessionStorage.setItem(REPAIR_FLAG, '1');
        window.location.reload();
      })
      .catch(function () { /* leave the basket exactly as the customer built it */ });

    return true;
  }

  Promise.all([
    json('/cart.js'),
    json('/products/' + CONFIG.SLICE_HANDLE + '.js')
  ]).then(function (res) {
    var cart = res[0], product = res[1];

    /* Repair first: if anything was missing the page is about to reload, and
       drawing an upsell onto a basket that is one line out of date would show
       the wrong next tier. */
    if (repairMissing(cart, product)) return;

    styles();

    [].forEach.call(root.querySelectorAll('.mb-line[data-group]'), function (row) {
      if (row.querySelector('[data-mb-upsell]')) return;

      var group = row.getAttribute('data-group');
      var card  = parentLine(cart, group);
      if (!card) return;

      var existing = sliceLine(cart, group, product.id);
      var curTitle = existing ? existing.variant_title || (existing.variant_options || [])[0] : null;
      var curIdx   = curTitle ? tierIndex(curTitle) : -1;

      if (curTitle && curIdx === -1) return;

      var nextTier = CONFIG.TIERS[curIdx + 1];
      if (!nextTier) return;

      var nextVariant = product.variants.filter(function (v) {
        return v.title === nextTier.title && v.available;
      })[0];
      if (!nextVariant) return;

      var curPrice = existing ? existing.original_price : 0;
      var uplift   = nextVariant.price - curPrice;
      if (uplift <= 0) return;

      var flavs    = flavoursOf(card.properties);
      var newSlots = nextTier.total - (flavs.length || 1);
      if (newSlots <= 0) return;

      build(row, card, curTitle, { id: nextVariant.id, title: nextTier.title },
            uplift, newSlots, flavs[0] || CONFIG.FLAVOURS[0], product);
    });
  }).catch(function () { });

  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-mb-flavour]');
    if (chip) {
      e.preventDefault();
      var slot = chip.closest('[data-mb-slot]');
      [].forEach.call(slot.querySelectorAll('[data-mb-flavour]'), function (c) {
        c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
      });
      var named = slot.querySelector('[data-mb-chosen]');
      if (named) named.textContent = chip.getAttribute('data-mb-flavour');
      return;
    }

    var open = e.target.closest('[data-mb-open]');
    if (open) {
      e.preventDefault();
      var p = open.closest('[data-mb-upsell]');
      if (CONFIG.MODE === 'quick') { commit(p, open); return; }
      open.hidden = true;
      p.querySelector('[data-mb-pick]').hidden = false;
      return;
    }

    var cancel = e.target.closest('[data-mb-cancel]');
    if (cancel) {
      e.preventDefault();
      var p2 = cancel.closest('[data-mb-upsell]');
      p2.querySelector('[data-mb-pick]').hidden = true;
      p2.querySelector('[data-mb-open]').hidden = false;
      return;
    }

    var go = e.target.closest('[data-mb-add]');
    if (go) { e.preventDefault(); commit(go.closest('[data-mb-upsell]'), go); }
  });

  function commit(panel, btn) {
    if (!panel || panel.getAttribute('data-mb-busy') === '1') return;
    panel.setAttribute('data-mb-busy', '1');
    var label = btn.textContent;
    btn.textContent = CONFIG.COPY.busy;

    var group     = panel.getAttribute('data-mb-group');
    var variantId = Number(panel.getAttribute('data-mb-variant'));
    var productId = panel.getAttribute('data-mb-product');
    var tierName  = panel.getAttribute('data-mb-tier');

    var cardQty = 1;
    var picks = [];
    [].forEach.call(panel.querySelectorAll('[data-mb-slot]'), function (slot) {
      var on = slot.querySelector('[data-mb-flavour][aria-pressed="true"]');
      picks.push({
        key: slot.getAttribute('data-mb-slot'),
        value: on ? on.getAttribute('data-mb-flavour') : slot.getAttribute('data-mb-default')
      });
    });

    json('/cart.js')
      .then(function (cart) {
        var card = parentLine(cart, group);
        if (!card) throw new Error('That card is no longer in your basket.');

        cardQty = Math.max(1, parseInt(card.quantity, 10) || 1);
        var props = {};
        Object.keys(card.properties || {}).forEach(function (k) { props[k] = card.properties[k]; });
        picks.forEach(function (p) { props[p.key] = p.value; });
        props[CONFIG.SLICE_PROP] = tierName;

        return post('/cart/change.js', { id: card.key, quantity: cardQty, properties: props });
      })
      .then(function () { return json('/cart.js'); })
      .then(function (cart) {
        var old = sliceLine(cart, group, productId);
        return old ? post('/cart/change.js', { id: old.key, quantity: 0 }) : null;
      })
      .then(function () {
        return post('/cart/add.js', {
          items: [{ id: variantId, quantity: cardQty, properties: { _mb_parent_group: group } }]
        });
      })
      .then(function () { window.location.reload(); })
      .catch(function (err) {
        panel.removeAttribute('data-mb-busy');
        btn.textContent = label;
        var warn = panel.querySelector('[data-mb-err]');
        if (warn) {
          warn.textContent = err.message || 'Sorry, we could not update your basket.';
          warn.hidden = false;
        }
      });
  }
})();